"use strict";
var __awaiter = (this && this.__awaiter) || function (thisArg, _arguments, P, generator) {
    function adopt(value) { return value instanceof P ? value : new P(function (resolve) { resolve(value); }); }
    return new (P || (P = Promise))(function (resolve, reject) {
        function fulfilled(value) { try { step(generator.next(value)); } catch (e) { reject(e); } }
        function rejected(value) { try { step(generator["throw"](value)); } catch (e) { reject(e); } }
        function step(result) { result.done ? resolve(result.value) : adopt(result.value).then(fulfilled, rejected); }
        step((generator = generator.apply(thisArg, _arguments || [])).next());
    });
};
var __generator = (this && this.__generator) || function (thisArg, body) {
    var _ = { label: 0, sent: function() { if (t[0] & 1) throw t[1]; return t[1]; }, trys: [], ops: [] }, f, y, t, g;
    return g = { next: verb(0), "throw": verb(1), "return": verb(2) }, typeof Symbol === "function" && (g[Symbol.iterator] = function() { return this; }), g;
    function verb(n) { return function (v) { return step([n, v]); }; }
    function step(op) {
        if (f) throw new TypeError("Generator is already executing.");
        while (_) try {
            if (f = 1, y && (t = op[0] & 2 ? y["return"] : op[0] ? y["throw"] || ((t = y["return"]) && t.call(y), 0) : y.next) && !(t = t.call(y, op[1])).done) return t;
            if (y = 0, t) op = [op[0] & 2, t.value];
            switch (op[0]) {
                case 0: case 1: t = op; break;
                case 4: _.label++; return { value: op[1], done: false };
                case 5: _.label++; y = op[1]; op = [0]; continue;
                case 7: op = _.ops.pop(); _.trys.pop(); continue;
                default:
                    if (!(t = _.trys, t = t.length > 0 && t[t.length - 1]) && (op[0] === 6 || op[0] === 2)) { _ = 0; continue; }
                    if (op[0] === 3 && (!t || (op[1] > t[0] && op[1] < t[3]))) { _.label = op[1]; break; }
                    if (op[0] === 6 && _.label < t[1]) { _.label = t[1]; t = op; break; }
                    if (t && _.label < t[2]) { _.label = t[2]; _.ops.push(op); break; }
                    if (t[2]) _.ops.pop();
                    _.trys.pop(); continue;
            }
            op = body.call(thisArg, _);
        } catch (e) { op = [6, e]; y = 0; } finally { f = t = 0; }
        if (op[0] & 5) throw op[1]; return { value: op[0] ? op[1] : void 0, done: true };
    }
};
var __read = (this && this.__read) || function (o, n) {
    var m = typeof Symbol === "function" && o[Symbol.iterator];
    if (!m) return o;
    var i = m.call(o), r, ar = [], e;
    try {
        while ((n === void 0 || n-- > 0) && !(r = i.next()).done) ar.push(r.value);
    }
    catch (error) { e = { error: error }; }
    finally {
        try {
            if (r && !r.done && (m = i["return"])) m.call(i);
        }
        finally { if (e) throw e.error; }
    }
    return ar;
};
var __spread = (this && this.__spread) || function () {
    for (var ar = [], i = 0; i < arguments.length; i++) ar = ar.concat(__read(arguments[i]));
    return ar;
};
Object.defineProperty(exports, "__esModule", { value: true });
exports.Documents = void 0;
var Bytes_1 = require("../../Bytes");
var DataWriter_1 = require("../../DataWriter");
var Base58_1 = require("../../../../crypt/libs/Base58");
var base64_1 = require("../../util/base64");
var Documents = /** @class */ (function () {
    function Documents(ms, msu, tm, tmu, pr, hsu, fu) {
        this.ms = ms;
        this.msu = msu;
        this.tm = tm;
        this.tmu = tmu;
        this.pr = pr;
        this.hsu = hsu;
        this.fu = fu;
        this.hs = undefined;
        this.f = [];
        this.files = [];
    }
    Documents.prototype.addFile = function (name, compressed, data) {
        var meta = {
            FN: name,
            ZP: compressed,
            SZ: data.length,
        };
        this.f.push(meta);
        this.files.push(data);
    };
    Documents.prototype.addHash = function (path, hash) {
        if (!this.hs) {
            this.hs = {};
        }
        this.hs[hash] = path;
    };
    Documents.prototype.json = function () {
        return {
            MS: this.ms,
            MSU: this.msu,
            TM: this.tm,
            TMU: this.tmu,
            PR: this.pr,
            HS: this.hs,
            HSU: this.hsu,
            F: __spread(this.f),
            FU: this.fu,
        };
    };
    Documents.prototype.jsonToBytes = function () {
        return __awaiter(this, void 0, void 0, function () {
            var jsonString;
            return __generator(this, function (_a) {
                switch (_a.label) {
                    case 0:
                        jsonString = JSON.stringify(this.json());
                        return [4 /*yield*/, Bytes_1.Bytes.stringToByteArray(jsonString)];
                    case 1: return [2 /*return*/, _a.sent()];
                }
            });
        });
    };
    Documents.prototype.toBytes = function () {
        return __awaiter(this, void 0, void 0, function () {
            var data, jsonBytes, i, bytes;
            return __generator(this, function (_a) {
                switch (_a.label) {
                    case 0:
                        data = new DataWriter_1.DataWriter();
                        return [4 /*yield*/, this.jsonToBytes()];
                    case 1:
                        jsonBytes = _a.sent();
                        return [4 /*yield*/, this.lengthToBytes(jsonBytes.length, data)];
                    case 2:
                        _a.sent();
                        data.set(jsonBytes);
                        // tslint:disable-next-line: prefer-for-of
                        for (i = 0; i < this.files.length; i += 1) {
                            bytes = this.files[i];
                            data.set(bytes);
                        }
                        return [2 /*return*/, data.data];
                }
            });
        });
    };
    Documents.prototype.lengthToBytes = function (length, dataWriter) {
        return __awaiter(this, void 0, void 0, function () {
            var bytes;
            return __generator(this, function (_a) {
                switch (_a.label) {
                    case 0: return [4 /*yield*/, Bytes_1.Bytes.intToByteArray(length)];
                    case 1:
                        bytes = _a.sent();
                        // console.log("lengthToBytes", { length, bytes });
                        dataWriter.set(bytes);
                        return [2 /*return*/];
                }
            });
        });
    };
    Documents.parse = function (raw) {
        return __awaiter(this, void 0, void 0, function () {
            var data, lengthBytes, length, position, jsonBytes, stringJson, json, MS, MSU, TM, TMU, PR, HSU, FU, documents;
            return __generator(this, function (_a) {
                switch (_a.label) {
                    case 0:
                        if (!base64_1.default.isBase64(raw)) return [3 /*break*/, 1];
                        data = base64_1.default.decodeToByteArray(raw);
                        return [3 /*break*/, 3];
                    case 1: return [4 /*yield*/, Base58_1.Base58.decode(raw)];
                    case 2:
                        data = _a.sent();
                        _a.label = 3;
                    case 3:
                        lengthBytes = data.slice(0, Documents.JSON_LENGTH);
                        return [4 /*yield*/, Bytes_1.Bytes.intFromByteArray(lengthBytes)];
                    case 4:
                        length = _a.sent();
                        position = Documents.JSON_LENGTH;
                        jsonBytes = data.slice(position, position + length);
                        return [4 /*yield*/, Bytes_1.Bytes.stringFromByteArray(jsonBytes)];
                    case 5:
                        stringJson = _a.sent();
                        json = JSON.parse(stringJson);
                        position += length;
                        MS = json.MS, MSU = json.MSU, TM = json.TM, TMU = json.TMU, PR = json.PR, HSU = json.HSU, FU = json.FU;
                        documents = new Documents(MS, MSU, TM, TMU, PR, HSU, FU);
                        if (json.HS) {
                            documents.hs = json.HS;
                        }
                        if (json.F) {
                            documents.f = json.F;
                            Object.values(json.F).forEach(function (meta) {
                                // READ FILE
                                var bytes = data.slice(position, position + meta.SZ);
                                documents.files.push(bytes);
                                position += meta.SZ;
                                // console.log("Documents.parse.file", meta);
                            });
                        }
                        return [2 /*return*/, documents];
                }
            });
        });
    };
    Documents.JSON_LENGTH = 4;
    return Documents;
}());
exports.Documents = Documents;
